import { useEffect, useState } from "react";
import api from "../../api/api";
import SideNavLayout from "../../customsidenav/sidenavlayout";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EmployeePhotoModal from "./employeephotomodal";
import { getPracticeId } from "../../config/practice";

const ViewOnBoardEmployees = () => {
  const practiseid = getPracticeId();
  const [employees, setEmployees] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchEmployees = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/onboarding-employee/get_all_details`
      );
      if (response?.status === 200) {
        setEmployees(response.data);
      } else {
        setEmployees([]);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleViewPhotos = (images) => {
    setSelectedImages(images);
    setOpenModal(true);
  };

  // Pagination calculations
  const totalPages = Math.ceil(employees.length / rowsPerPage);
  const paginatedEmployees = employees.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1)
      setCurrentPage((prev) => prev - 1);
    else if (direction === "next" && currentPage < totalPages)
      setCurrentPage((prev) => prev + 1);
  };

  return (
    <SideNavLayout>
      <div className="p-6 text-black">
        <h2 className="text-2xl font-semibold mb-6">Onboarded Employees</h2>

        {/* Table */}
        <div className="bg-white shadow-lg rounded-xl overflow-hidden border border-gray-200">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-[#50869A] text-[white] uppercase text-xs">
              <tr>
                <th className="px-4 py-3 font-semibold">#</th>
                <th className="px-4 py-3 font-semibold">Employee Name</th>
                <th className="px-4 py-3 font-semibold">Email</th>
                <th className="px-4 py-3 font-semibold">Phone</th>
                <th className="px-4 py-3 font-semibold">Created By</th>
                <th className="px-4 py-3 font-semibold text-center">Photos</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 text-gray-700">
              {paginatedEmployees.length > 0 ? (
                paginatedEmployees.map((emp, index) => (
                  <tr key={emp.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2">
                      {(currentPage - 1) * rowsPerPage + index + 1}
                    </td>
                    <td className="px-4 py-2 font-medium capitalize">
                      {emp.emp_name}
                    </td>
                    <td className="px-4 py-2">
                      {emp.employee_details?.email || "-"}
                    </td>
                    <td className="px-4 py-2">
                      {emp.employee_details?.phone || "-"}
                    </td>
                    <td className="px-4 py-2">{emp.created_by}</td>
                    <td className="px-4 py-2 text-center">
                      {emp.employee_images?.length > 0 ? (
                        <button
                          onClick={() => handleViewPhotos(emp.employee_images)}
                          className="p-1.5 rounded-full bg-[#50869A] text-[white] hover:bg-[#417080] transition"
                          title="View Photos"
                        >
                          <VisibilityIcon fontSize="small" />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center text-gray-500 italic py-4"
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {employees.length > 0 && (
            <div className="flex items-center justify-between px-4 py-3 text-sm text-gray-600 bg-gray-50">
              <div className="flex items-center gap-2">
                <span>Rows per page:</span>
                <select
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  className="border rounded-md px-2 py-1"
                >
                  {[5, 10, 15, 20].map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex items-center gap-4">
                <button
                  onClick={() => handlePageChange("prev")}
                  disabled={currentPage === 1}
                  className={`px-3 py-1 rounded-md border ${
                    currentPage === 1
                      ? "text-gray-400 border-gray-300"
                      : "text-[#50869A] border-[#50869A]"
                  }`}
                >
                  Prev
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => handlePageChange("next")}
                  disabled={currentPage === totalPages}
                  className={`px-3 py-1 rounded-md border ${
                    currentPage === totalPages
                      ? "text-gray-400 border-gray-300"
                      : "text-[#50869A] border-[#50869A]"
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      <EmployeePhotoModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        images={selectedImages}
      />
    </SideNavLayout>
  );
};

export default ViewOnBoardEmployees;
